<template>
    <v-dialog v-model="dialogSwitch" persistent scrollable width="700">
        <v-form v-model="generalFormData.valid" class="mb-3" validate-on="input lazy" @submit.prevent="storeTemplate">
            <v-card>
                <v-card-title id="heading" class="d-flex justify-space-between">
                    <h4 class="text-capitalize">General Config</h4>
                    <v-btn density="compact" icon="mdi-close" variant="flat" @click="$emit('update:modelValue',false)"/>
                </v-card-title>

                <v-container>
                    <v-alert v-if="errors.length" class="mb-3 bg-error" closable close-label="Close Alert"
                             density="compact" variant="tonal">
                        <p v-for="error in errors">{{ error }}</p>
                    </v-alert>
                    <v-row>
                        <v-col cols="6">
                            <v-switch v-model="generalFormData['periodic_reboot_status']"
                                      :rules="[vRules.required]"
                                      color="primary"
                                      density="compact"
                                      label="Periodic Reboot Status"
                            />
                        </v-col>
                        <v-col cols="6">
                            <v-switch v-model="generalFormData['lte_scan_status']"
                                      :rules="[vRules.required]"
                                      color="primary"
                                      density="compact"
                                      label="LTE Scan Status"
                            />
                        </v-col>
                        <v-col cols="6">
                            <v-switch v-model="generalFormData['ble_scan_status']"
                                      :rules="[vRules.required]"
                                      color="primary"
                                      density="compact"
                                      label="BLE Scan Status"
                            />
                        </v-col>
                        <v-col cols="6">
                            <v-switch v-model="generalFormData['wifi_scan_status']"
                                      :rules="[vRules.required]"
                                      color="primary"
                                      density="compact"
                                      label="Wifi Scan Status"
                            />
                        </v-col>

                        <v-col class="py-0" cols="12">
                            <v-text-field v-model="generalFormData['label']" autofocus
                                          :rules="[vRules.required,vRules.maxLength(64)]"
                                          density="compact" label="Label"/>
                        </v-col>
                        <v-col class="py-0" cols="12" sm="6">
                            <v-text-field v-model="generalFormData['network_diagnostics_status']"
                                          :rules="[vRules.required]"
                                          density="compact"
                                          label="Network Diagnostic Status"
                                          type="number"
                            />
                        </v-col>

                        <v-col class="py-0" cols="12" sm="6">
                            <v-text-field v-model="generalFormData['gateway_timeout_in_milli_seconds']"
                                          :rules="[vRules.required]"
                                          density="compact"
                                          hint=" Milliseconds"
                                          label="Gateway Timeout"
                                          type="number"/>
                        </v-col>
                        <v-col class="py-0" cols="12" sm="6">
                            <v-text-field v-model="generalFormData['movement_starts_alert_flag']"
                                          :rules="[vRules.required]"
                                          density="compact"
                                          label="Movement Start Alert Flag"
                                          type="number"/>
                        </v-col>
                        <v-col class="py-0" cols="12" sm="6">
                            <v-text-field v-model="generalFormData['network_registration_timeout_in_seconds']"
                                          :rules="[vRules.required]"
                                          density="compact"
                                          hint="Seconds"
                                          label="Network Registration Timeout"
                                          type="number"/>
                        </v-col>

                        <v-col class="py-0" cols="12" sm="6">
                            <v-text-field v-model="generalFormData['periodic_reboot_interval_seconds']"
                                          :rules="[vRules.required]"
                                          density="compact"
                                          hint="Minutes"
                                          label="Periodic Reboot Interval"
                                          type="number"/>
                        </v-col>

                        <v-col class="py-0" cols="12" sm="6">
                            <v-text-field v-model="generalFormData['server_acknowledgment_seconds']"
                                          :rules="[vRules.required]"
                                          density="compact"
                                          hint="Seconds"
                                          label="Server Acknowledgment"
                                          type="number"/>
                        </v-col>


                        <v-col class="py-0" cols="12" sm="6">
                            <v-text-field v-model="generalFormData['network_diagnostics_period_seconds']"
                                          :rules="[vRules.required]"
                                          density="compact"
                                          hint="Seconds"
                                          label="Network Diagnostic Period"
                                          type="number"/>
                        </v-col>

                        <v-col class="py-0" cols="12" sm="6">
                            <v-text-field v-model="generalFormData['heartbeat_packet_seconds']"
                                          :rules="[vRules.required]"
                                          density="compact"
                                          hint="Seconds"
                                          label="Heartbeat Packet"
                                          type="number"/>
                        </v-col>

                        <v-col class="py-0" cols="12" sm="6">
                            <v-text-field v-model="generalFormData['movement_progress_alert_seconds']"
                                          :rules="[vRules.required]"
                                          density="compact"
                                          hint="Seconds"
                                          label="Movement Progress Alert"
                                          type="number"/>
                        </v-col>

                        <v-col class="py-0" cols="12" sm="6">
                            <v-text-field v-model="generalFormData['activity_threshold_x_axes']"
                                          :rules="[vRules.required]"
                                          density="compact"
                                          label="Activity Threshold X Axes"
                                          type="number"/>
                        </v-col>

                        <v-col class="py-0" cols="12" sm="6">
                            <v-text-field v-model="generalFormData['activity_threshold_y_axes']"
                                          :rules="[vRules.required]"
                                          density="compact"
                                          label="Activity Threshold Y Axes"
                                          type="number"/>
                        </v-col>

                        <v-col class="py-0" cols="12" sm="6">
                            <v-text-field v-model="generalFormData['activity_threshold_z_axes']"
                                          :rules="[vRules.required]"
                                          density="compact"
                                          label="Activity Threshold Z Axes"
                                          type="number"/>
                        </v-col>

                        <v-col class="py-0" cols="12" sm="6">
                            <v-text-field v-model="generalFormData['seconds_per_sample']"
                                          :rules="[vRules.required]"
                                          density="compact"
                                          label="Seconds per sample"
                                          type="number"/>
                        </v-col>

                        <v-col class="py-0" cols="12" sm="6">
                            <v-text-field v-model="generalFormData['minimum_activity_interrupts_needed_per_sample']"
                                          :rules="[vRules.required]"
                                          density="compact"
                                          hint="Per sample"
                                          label="Minimum activity interrupts needed"
                                          type="number"/>
                        </v-col>

                        <v-col class="py-0" cols="12" sm="6">
                            <v-text-field v-model="generalFormData['fifo_size']"
                                          :rules="[vRules.required]"
                                          density="compact"
                                          label="FIFO Size"
                                          type="number"/>
                        </v-col>

                        <v-col class="py-0" cols="12" sm="6">
                            <v-text-field v-model="generalFormData['fifo_movement_start_thresholds']"
                                          @blur="updateMovementFifoThreshold"
                                          :rules="[vRules.required]"
                                          density="compact"
                                          label="FIFO movement starts thresholds"
                                          type="number"/>
                        </v-col>

                        <v-col class="py-0" cols="12" sm="6">
                            <v-text-field v-model="generalFormData['fifo_movement_continue_thresholds']"
                                          :rules="[vRules.required]"
                                          density="compact"
                                          label="FIFO movement continue thresholds"
                                          type="number"/>
                        </v-col>

                        <v-col class="py-0" cols="12" sm="6">
                            <v-text-field v-model="generalFormData['gps_minimum_accuracy_idle']"
                                          :rules="[vRules.required]"
                                          density="compact"
                                          hint="Idle"
                                          label="GPS minimum accuracy (Idle)"
                                          type="number"/>
                        </v-col>

                        <v-col class="py-0" cols="12" sm="6">
                            <v-text-field v-model="generalFormData['gps_minimum_accuracy_movement']"
                                          :rules="[vRules.required]"
                                          density="compact"
                                          hint="Movement"
                                          label="GPS minimum accuracy (Movement)"
                                          type="number"/>
                        </v-col>

                        <v-col class="py-0" cols="12" sm="6">
                            <v-text-field v-model="generalFormData['gps_fix_timeout_idle_seconds']"
                                          :rules="[vRules.required]"
                                          density="compact"
                                          hint="Idle in seconds"
                                          label="GPS fix timeout (Idle)"
                                          type="number"/>
                        </v-col>

                        <v-col class="py-0" cols="12" sm="6">
                            <v-text-field v-model="generalFormData['gps_fix_timeout_movement_seconds']"
                                          :rules="[vRules.required]"
                                          density="compact"
                                          hint="Movement in seconds"
                                          label="GPS fix timeout (Movement)"
                                          type="number"/>
                        </v-col>

                        <v-col class="py-0" cols="12" sm="6">
                            <v-text-field v-model="generalFormData['packet_retransmit_attempts']"
                                          :rules="[vRules.required]"
                                          density="compact"
                                          label="Packet Retransmit attempts"
                                          type="number"/>
                        </v-col>

                        <v-col class="py-0" cols="12" sm="6">
                            <v-text-field v-model="generalFormData['lte_scan_trigger_timeout']"
                                          :rules="[vRules.required]"
                                          density="compact"
                                          hint="Seconds"
                                          label="LTE Scan Trigger Timeout"
                                          type="number"/>
                        </v-col>

                        <v-col class="py-0" cols="12" sm="6">
                            <v-text-field v-model="generalFormData['ble_scan_timeout']"
                                          :rules="[vRules.required]"
                                          density="compact"
                                          hint="Seconds"
                                          label="BLE Scan Timeout"
                                          type="number"/>
                        </v-col>

                        <v-col class="py-0" cols="12" sm="6">
                            <v-text-field v-model="generalFormData['ble_scan_trigger_timeout']"
                                          :rules="[vRules.required]"
                                          density="compact"
                                          hint="Seconds"
                                          label="BLE Scan Trigger Timeout"
                                          type="number"/>
                        </v-col>

                        <v-col class="py-0" cols="12" sm="6">
                            <v-text-field v-model="generalFormData['wifi_scan_timeout']"
                                          :rules="[vRules.required]"
                                          density="compact"
                                          hint="Seconds"
                                          label="Wifi Scan Timeout"
                                          type="number"/>
                        </v-col>

                        <v-col class="py-0" cols="12" sm="6">
                            <v-text-field v-model="generalFormData['wifi_scan_trigger_timeout']"
                                          :rules="[vRules.required]"
                                          density="compact"
                                          hint="Seconds"
                                          label="Wifi Scan Trigger Timeout"
                                          type="number"/>
                        </v-col>

                        <v-col class="py-0" cols="12" sm="6">
                            <v-text-field v-model="generalFormData['max_stationary_progress_interval']"
                                          :rules="[vRules.required]"
                                          density="compact"
                                          hint="Seconds"
                                          label="Max Stationary Progress Interval"
                                          type="number"/>
                        </v-col>

                        <v-col class="py-0" cols="12" sm="6">
                            <v-text-field v-model="generalFormData['ble_scan_interval']"
                                          :rules="[vRules.required]"
                                          density="compact"
                                          label="Ble Scan Interval"
                                          type="number"/>
                        </v-col>

                        <v-col class="py-0" cols="12" sm="6">
                            <v-text-field v-model="generalFormData['ble_scan_window']"
                                          :rules="[vRules.required]"
                                          density="compact"
                                          label="Ble Scan Window"
                                          type="number"/>
                        </v-col>

                        <v-col class="py-0" cols="12" sm="6">
                            <v-text-field v-model="generalFormData['movement_instantaneous_fifo_threshold']"
                                          :rules="[vRules.required]"
                                          density="compact"
                                          label="Movement Instantaneous FIFO Threshold"
                                          type="number"/>
                        </v-col>

                        <v-col class="py-0" cols="12" sm="6">
                            <v-text-field v-model="generalFormData['movement_algo_type']"
                                          density="compact"
                                          label="Movement Algo Type"
                                          type="number"/>
                        </v-col>
                        <v-col class="py-0" cols="12" sm="6">
                            <v-switch v-model="generalFormData['ignition_on_ext_gpi1']"
                                      color="primary"
                                      density="compact"
                                      hide-details
                                      label="Ignition is on EXT GPI1"/>
                            <p class="text-caption text-medium-emphasis">
                                Orion Fleet only. The tracker watches EXT GPI1 itself, with no External I/O template attached, and reports movement for as long as the line is active.
                            </p>
                        </v-col>

                        <v-col class="py-0" cols="12" sm="6">
                            <v-select v-model="generalFormData['ignition_ext_gpi1_active_level']"
                                      :disabled="!generalFormData['ignition_on_ext_gpi1']"
                                      :items="ignitionActiveLevels"
                                      density="compact"
                                      item-title="label"
                                      item-value="value"
                                      label="EXT GPI1 Active State"/>
                        </v-col>
                    </v-row>
                </v-container>

                <v-card-actions class="px-4 d-flex justify-end">
                    <v-btn size="small" type="button"
                           @click="$emit('update:modelValue',false)">
                        Close
                    </v-btn>
                    <v-btn color="primary" size="small" type="submit">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </v-dialog>
</template>

<script setup>
import {ref, reactive, onMounted} from "vue";
import {send} from "@/composables/apiClient";
import {useSnackbarStore} from "@/stores/snackBarStore";

const props = defineProps({
    type: String,
    plan: Object,
    modelValue: Boolean,
});
const errors = ref([]);
const snackbar = useSnackbarStore();
const dialogSwitch = ref(props.modelValue);
// Matches the firmware's own encoding so there is one convention rather than two:
// EXT_GPO_ACTIVE_LEVEL_HIGH = 0, EXT_GPO_ACTIVE_LEVEL_LOW = 1. Active high is also
// what the firmware assumes when no External I/O config is present.
const ignitionActiveLevels = [
    {value: 0, label: 'Active High - ignition on when the line is high'},
    {value: 1, label: 'Active Low - ignition on when the line is low'},
];
const generalFormData = reactive({
    valid: false,
    id: null,
    label: null,
    plan_id: props.plan.id,
    ignition_on_ext_gpi1: false,
    ignition_ext_gpi1_active_level: 0,
});
const emits = defineEmits(['update:modelValue']);
onMounted(() => {
    getTemplate()
})

const updateMovementFifoThreshold = () => {
    if (!generalFormData['movement_instantaneous_fifo_threshold']) {
        generalFormData['movement_instantaneous_fifo_threshold'] = generalFormData['fifo_movement_start_thresholds'];
    }
}
const getTemplate = () => {
    send('get', `monitoring/general-template-for-plan/${props.plan.id}`)
        .then((response) => {
            const gcTemplate = response.data.data;
            if (gcTemplate) {
                Object.keys(gcTemplate).forEach((key) => {
                    if (gcTemplate[key] !== undefined) {
                        generalFormData[key] = gcTemplate[key];
                    }
                })
            } else {
                send('get', `monitoring/preset-general-config`)
                    .then((response) => {
                        const presetConfig = response.data.data;
                        if (presetConfig) {
                            const restrictedKeys = ['id', 'label', 'company_id', 'plan_id', 'created_at', 'updated_at'];
                            Object.keys(presetConfig).forEach((key) => {
                                if (presetConfig[key] !== undefined) {
                                    if (!restrictedKeys.includes(key)) {
                                        generalFormData[key] = presetConfig[key];
                                    }
                                }
                            })
                        }
                    })
                    .catch(function (errorResponse) {
                        snackbar.showSnackbar('Something went wrong', 'error');
                    })
            }
        })
        .catch(function () {
            snackbar.showSnackbar('Something went wrong', 'error');
            document.getElementById('heading').scrollIntoView({behavior: 'smooth'});
        })
}
const storeTemplate = () => {
    errors.value = [];
    send(`${generalFormData['id'] ? 'put' : 'post'}`,
        `monitoring/general-templates${generalFormData['id'] ? `/${generalFormData['id']}` : ''}`,
        generalFormData)
        .then((response) => {
            snackbar.showSnackbar(response.data.message);
            if (response.data.success) {
                emits('update:modelValue', false);
            }
        })
        .catch(function (errorResponse) {
            if (errorResponse.response.data.errors) {
                let validationErrors = errorResponse.response.data.errors;
                Object.keys(validationErrors).forEach((key) => {
                    errors.value.push(validationErrors[key][0]);
                });
            } else if (errorResponse.response.data.message) {
                errors.value.push(errorResponse.response.data.message);
            }
            snackbar.showSnackbar('Something went wrong', 'error');
            document.getElementById('heading').scrollIntoView({behavior: 'smooth'});
        })
}

</script>
